'use strict';

function updateBirthday(day, month, year, birthday) {
    var $day = $(day),
        $month = $(month),
        $year = $(year),
        $birthday = $(birthday);

    if ($day.val() && $month.val() && $year.val()) {
        $birthday.val($month.val() + '/' + $day.val() + '/' + $year.val());
    } else {
        $birthday.val('');
    }
}

function updateCourseDate(month, year, date, isLastDay) {
    var $month = $(month),
        $year = $(year),
        $date = $(date);

    function daysInMonth(month, year) {
        return new Date(year, month, 0).getDate();
    }

    if ($month.val() && $year.val()) {
        if (isLastDay) {
            $date.val($month.val() + '/' + daysInMonth(+$month.val(), +$year.val()) + '/' + $year.val());
        } else {
            $date.val($month.val() + '/01/' + $year.val());
        }
    } else {
        $date.val('');
    }
}

module.exports = {
    updateBirthday: updateBirthday,
    updateCourseDate: updateCourseDate
};